
<div class="flex items-center justify-center w-full" [ngClass]="overlay ? 'min-h-[80px]' : 'min-h-[200px]'" aria-busy="true">
    @if (type === 'grid') {
        <div class="grid gap-4 w-full p-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            @for (i of _items; track i) {
                <div class="skel-card">
                    <div class="skel skel-block h-32"></div>
                    <div class="space-y-2 pt-3">
                        <div class="skel skel-line w-2/3"></div>
                        <div class="skel skel-line w-1/2"></div>
                    </div>
                </div>
            }
        </div>
    } @else if (type === 'detail') {
        <div class="w-full p-6 space-y-4">
            <div class="skel skel-line w-1/3 h-6"></div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                @for (i of _items3; track i) {
                    <div class="space-y-2">
                        <div class="skel skel-line w-1/2"></div>
                        <div class="skel skel-line w-full"></div>
                    </div>
                }
            </div>
            <div class="skel skel-block h-48"></div>
        </div>
    } @else if (type === 'project-cards') {
        <div class="grid gap-6 w-full sm:grid-cols-2 lg:grid-cols-3">
            @for (i of _items; track i) {
                <div class="skel-card">
                    <div class="skel skel-block h-36"></div>
                    <div class="p-5 space-y-4">
                        <div class="flex items-start justify-between gap-3">
                            <div class="flex-1 space-y-2">
                                <div class="skel skel-line w-2/3 h-5"></div>
                                <div class="flex items-center gap-2">
                                    <div class="skel w-3.5 h-3.5 rounded-full"></div>
                                    <div class="skel skel-line w-1/2"></div>
                                </div>
                                <div class="skel skel-line w-1/4 h-3"></div>
                                <div class="flex items-center gap-2 mt-1">
                                    <div class="skel skel-circle w-9 h-9"></div>
                                    <div class="flex-1 space-y-1.5">
                                        <div class="skel skel-line w-1/3 h-3"></div>
                                        <div class="skel skel-line w-1/2 h-3"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="skel w-20 h-6 rounded-full"></div>
                        </div>
                        <div class="space-y-1.5">
                            <div class="skel skel-line w-full"></div>
                            <div class="skel skel-line w-4/5"></div>
                            <div class="skel skel-line w-2/3"></div>
                        </div>
                        <div class="flex flex-wrap gap-2">
                            <div class="skel w-16 h-6 rounded-full"></div>
                            <div class="skel w-20 h-6 rounded-full"></div>
                            <div class="skel w-14 h-6 rounded-full"></div>
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div class="space-y-2 rounded-lg border border-[color:var(--border)] p-2.5">
                                <div class="skel skel-line w-2/3 h-2.5"></div>
                                <div class="skel skel-line w-full h-4"></div>
                            </div>
                            <div class="space-y-2 rounded-lg border border-[color:var(--border)] p-2.5">
                                <div class="skel skel-line w-2/3 h-2.5"></div>
                                <div class="skel skel-line w-full h-4"></div>
                            </div>
                        </div>
                        <div class="skel w-full h-9 rounded-md"></div>
                    </div>
                </div>
            }
        </div>
    } @else if (type === 'project-detail') {
        <div class="w-full space-y-6" role="status" aria-label="Loading project">
            <!-- Hero card: image banner with overlaid title + status, then body sections -->
            <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] overflow-hidden">
                <div class="relative h-56 w-full">
                    <div class="skel skel-block h-full rounded-none"></div>
                    <div class="absolute left-4 sm:left-6 bottom-4 flex items-center gap-3">
                        <div class="skel w-12 h-12 rounded-xl"></div>
                        <div class="space-y-2">
                            <div class="skel skel-line w-16 h-3"></div>
                            <div class="skel skel-line w-48 h-6"></div>
                        </div>
                    </div>
                    <div class="absolute right-4 sm:right-6 top-4">
                        <div class="skel w-24 h-7 rounded-full"></div>
                    </div>
                </div>
                <div class="p-4 sm:p-6 space-y-6">
                    <!-- Description -->
                    <div class="space-y-3">
                        <div class="skel skel-line w-1/4 h-5"></div>
                        <div class="rounded-xl border border-[color:var(--border)] p-4 space-y-2">
                            <div class="skel skel-line w-full"></div>
                            <div class="skel skel-line w-11/12"></div>
                            <div class="skel skel-line w-3/4"></div>
                        </div>
                    </div>
                    <!-- Company -->
                    <div class="pt-4 border-t border-[color:var(--border)] flex items-center gap-3">
                        <div class="skel skel-circle w-12 h-12"></div>
                        <div class="flex-1 space-y-2">
                            <div class="skel skel-line w-24 h-3"></div>
                            <div class="skel skel-line w-1/3"></div>
                        </div>
                    </div>
                    <!-- Location -->
                    <div class="pt-4 border-t border-[color:var(--border)] space-y-3">
                        <div class="skel skel-line w-1/5 h-5"></div>
                        <div class="skel skel-line w-2/3"></div>
                    </div>
                </div>
            </div>
            <!-- Tabbed list card (phases / properties) -->
            <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-4 sm:p-6 space-y-4">
                <div class="flex items-center gap-3">
                    <div class="skel w-24 h-8 rounded-lg"></div>
                    <div class="skel w-24 h-8 rounded-lg"></div>
                </div>
                <div class="space-y-3 pt-2">
                    @for (i of _items3; track i) {
                        <div class="skel-row rounded-xl border border-[color:var(--border)] p-3">
                            <div class="skel skel-block w-16 h-16 rounded-lg" style="flex: 0 0 auto;"></div>
                            <div class="flex-1 space-y-2">
                                <div class="skel skel-line w-2/3"></div>
                                <div class="skel skel-line w-1/3"></div>
                            </div>
                            <div class="skel w-20 h-6 rounded-full"></div>
                        </div>
                    }
                </div>
            </div>
        </div>
    } @else {
        <div class="w-full p-4 space-y-3">
            @for (i of _items; track i) {
                <div class="skel-row">
                    <div class="skel skel-circle"></div>
                    <div class="flex-1 space-y-2">
                        <div class="skel skel-line w-3/4"></div>
                        <div class="skel skel-line w-1/2"></div>
                    </div>
                </div>
            }
        </div>
    }
</div>

